import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import icVisibility from '@iconify/icons-ic/twotone-visibility';
import icVisibilityOff from '@iconify/icons-ic/twotone-visibility-off';
import { fadeInUp400ms } from '../../../@vex/animations/fade-in-up.animation';
import { EmailValidator } from 'src/app/services/email.validator';
import { active_session_details, UsersService } from './../../services/users.service';
import { AppConfigService } from './../../services/app-config.service';
import { LoadingService } from './../../services/loading.service';
import { CookieService } from 'ngx-cookie-service';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { Message } from 'src/app/interfaces/message.model';


@Component({
  selector: 'vex-session-login',
  templateUrl: './session-login.component.html',
  styleUrls: ['./session-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    fadeInUp400ms
  ]
})
export class SessionLoginComponent implements OnInit {

  userEmailLogin: FormGroup;
  floatLabelControl = new FormControl('always');
  loginStatus: boolean = false;
  user_det: any;
  session: string = '';
  errorStatus: boolean = false;
  statusMessage: any;
  form: FormGroup;

  inputType = 'password';
  visible = false;

  icVisibility = icVisibility;
  icVisibilityOff = icVisibilityOff;
  privilegesObj: any = {};

  constructor(@Inject(MAT_DIALOG_DATA)
    private data,
    private dialogRef: MatDialogRef<SessionLoginComponent>,
    private router: Router,
    private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    private snackbar: MatSnackBar,
    private userService: UsersService,
    private appConfigService: AppConfigService,
    private loadingService: LoadingService,
    private broadcastService : BroadcastService,
    private CookieService:CookieService
    ) {
      this.dialogRef.disableClose = true
     }

     @HostListener('document:keypress', ['$event'])
     keyEvent(event: KeyboardEvent) {
       if (event.key === "Enter") {
         this.onUserEmailLogin(this.userEmailLogin)
       }
   }

  ngOnInit(): void {
    //console.log(this.data);

    this.userEmailLogin = this.fb.group({
      login_email: new FormControl('', Validators.compose([Validators.required, Validators.email,Validators.pattern(/[a-z0-9]+@[a-z0-9]+\.[a-z0-9]{2,2}/), EmailValidator.cannotContainSpace])),
      login_email_password: new FormControl('', [ Validators.required])
    })
  }

  send() {
    this.router.navigate(['/dashboard']);
    this.snackbar.open('Lucky you! Looks like you didn\'t need a password or email address! For a real application we provide validators to prevent this. ;)', 'LOL THANKS', {
      duration: 10000
    });
  }

  toggleVisibility() {
    if (this.visible) {
      this.inputType = 'password';
      this.visible = false;
      this.cd.markForCheck();
    } else {
      this.inputType = 'text';
      this.visible = true;
      this.cd.markForCheck();
    }
  }

  checkWhitSpaces(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode === 32) {
      return false;
    }
    return true;
  }

  getUserPrivileges(data) {
    let values = data;
    // //console.log(data)
    if(values !== null){
      for (let i = 0; i < values.length; i++) {
        this.privilegesObj[values[i]] = true
      }
      // //console.log(this.privilegesObj);

      //setting the privileges obj in cookies to make the data accessible to all other components
      this.CookieService.set('userPrivilegesObj', JSON.stringify(this.privilegesObj));
    }

  }

  onUserEmailLogin(userCredentials: any){
    this.loadingService.showLoader();
    //console.log("the user details are",userCredentials)
    if(userCredentials.status === "VALID"){
      //console.log(userCredentials);

      let url = location.href;
      if(url.split("#")[1] != "/"){
        // this.loadingService.hideLoader();
      }

      this.userService.emailLogin(userCredentials).subscribe(
      (response) => {
        var userId = response['data']['active_session'];
        this.loginStatus = true;
        console.log("the login",response)
        this.user_det = {
          status: true,
          user_session_id: userId,
          user_name: response["data"]["first_name"],
          user_email: response["data"]["email"],
          user_cms_token : response["data"]["auth_token"],
          user_privileges: response["data"]["user_privileges"],
          user_role: response["data"]["user_role"],
          cms_bg_id: response['data']['bg_id'],
          transcode_bg_id: response['data']['bg_id'],
          business_group_id: response['data']['business_group_id'],
          tenant_ids: response['data']['bg_tenants']
        }
        this.userService.setUserLocalStorage(this.user_det);
        this.appConfigService.loadCmsKeys(this.user_det.user_cms_token);
        this.getUserPrivileges(response["data"]["user_privileges"])
        // localStorage.setItem('loggedInUserDetails', JSON.stringify(response.data))
        this.session = userId;
        let url = location.href;
        if(this.data.url){
          this.dialogRef.close('yes')
        }
        this.loadingService.hideLoader();
        // this.broadcastService.dispatch(new Message('loginstatus', this.session));        
        },
        (error: any) => {
          this.loadingService.hideLoader();
          //console.log("the error is",error.server_error_messsage)
          this.snackbar.open(error.server_error_messsage, '', {
            duration: 3000,
            panelClass: 'snackbar-container'
          });
        }
      );
  }
 }

}
